export const authStorage = sessionStorage;

export const localStorageUser = "qvale_admin";

export const localStorageToken = "qvale_token";

export const theme1Id = "6d7b8d59-4a97-4b38-aa99-e0613d8d4f25";

export const sessionTimeBeforeIdleInSeconds = 1800;

export const channelSaleColors = [
  "rgb(74, 140, 168)",
  "rgb(235, 100, 59)",
  "rgb(247, 204, 71)",
];

const productObject = {
  // productId: "string",
  productName: "",
  productDescription: "",
  // productSpecs: "string",
  // productCode: "string",
  productType: "PHYSICAL",
  productPriceMin: 0,
  productPriceMax: 0,
  // productSalesChannel: "ONLINE",
  productVendor: "",
  // productOptionCombination: "string",
  // productTags: "string",
  taxable: false,
  // seoTags: "string",
  seoProductTitle: "",
  seoProductDesc: "",
  seoProductUrl: "",
  deleted: false,
  storeId: "loggedInUser?.storeId", // Work on this
  // createdBy: "", //Work on this
  // lastUpdatedDate: "2023-09-25T00:38:36.393Z",
  brand: "",
  manufacturer: "",
  status: {
    sysProductStatusId: 0,
    // status: "string",
    // label: "string",
    // desc: "string",
    // deleted: true,
  },
  images: [
    // {
    //   productImageId: 0,
    //   imageUrl:
    //     "https://plus.unsplash.com/premium_photo-1664391847942-f9c4562ad692?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2866&q=80",
    //   imageHeight: 0,
    //   imageWidth: 0,
    //   imageAltText: "string",
    //   thumbnailImage: true,
    //   productImage: null,
    // },
  ],
  variants: [
    {
      // productVariantId: "string",
      // title: "string",
      sku: "",
      barcode: "",
      // storeProductOption1Id: 0,
      // storeProductOption1Value: "string",
      // storeProductOption2Id: 0,
      // storeProductOption2Value: "string",
      // storeProductOption3Id: 0,
      // storeProductOption3Value: "string",
      // storeProductOption4Id: 0,
      // storeProductOption4Value: "string",
      // storeProductOption5Id: 0,
      // storeProductOption5Value: "string",
      // unitPriceMeasuredType: "AREA",
      // unitPriceMeasuredQtyUnit: "L",
      // unitPriceMeasuredQtyValue: 0,
      // unitPriceMeasuredQtyValueMax: 0,
      // unitPriceMeasuredQtyIncrementValue: 0,
      // shippingWeight: 0,
      // shippingWeightUnit: "lb",
      // onlineStoreUrl: "string",
      // availableForSale: true,
      costPerItem: 0,
      // harmonizedSystemCode: "string",
      // metadata: "string",
      displayOrder: 0,
      // deleted: false,
      // originCountryId: 0,
      storeId: "loggedInUser?.storeId",
      // createdBy: "",
      // lastUpdatedDate: "2023-09-25T00:38:36.393Z",
      // images: [
      //   {
      //     productImageId: 0,
      //     imageUrl: "string",
      //     imageHeight: 0,
      //     imageWidth: 0,
      //     imageAltText: "string",
      //     thumbnailImage: true,
      //     deleted: true,
      //     createdBy: "string",
      //     lastUpdatedDate: "2023-09-25T00:38:36.393Z",
      //   },
      // ],
      price: [
        {
          //     productPriceId: 0,
          productPrice: 0,
          compareAtPrice: 0,
          effectiveStartDate: "2023-09-27T00:38:36.393Z",
          effectiveEndDate: "2024-09-25T00:38:36.393Z",
          sysCurrencyId: 1,
          storeLocationId: "string",
          //     createdBy: "string",
          //     lastUpdatedDate: "2023-09-25T00:38:36.393Z",
        },
      ],
      inventorys: [
        {
          // productInventoryId: 0,
          availableInventory: "0",
          backroomInventory: "0",
          restockThresholdQty: "0",
          // inventoryUpdateChannel: "PORTAL",
          storeLocationId: "",
          // createdBy: "",
          // lastUpdatedDate: "2023-09-25T00:38:36.393Z",
        },
      ],
    },
  ],
  categories: [
    {
      // categoryMappingId: 0,
      storeId: "loggedInUser?.storeId",
      // compositeKey: "string",
      category: {
        categoryId: null,
        // categoryName: "string",
        // categoryCode: "string",
        // categoryDesc: "string",
        // displayOrder: 0,
        // storeId: "string",
        // linkedProductCount: 0,
        // taxable: true,
      },
      subCategoryLevel1: {
        subCategoryId: 0,
        // subCategoryName: "string",
        // subCategoryCode: "string",
        // subCategoryDesc: "string",
        // taxable: true,
        // displayOrder: 0,
        // storeId: "string",
        // linkedProductCount: 0,
      },
      subCategoryLevel2: {
        subCategoryId: 0,
        // subCategoryName: "string",
        // subCategoryCode: "string",
        // subCategoryDesc: "string",
        // taxable: true,
        // displayOrder: 0,
        // storeId: "string",
        // linkedProductCount: 0,
      },
    },
  ],
};
